import React from 'react';
import './Dashboard.css';

const tools = [
    { id: 'tracking', title: 'Tracking', icon: '🔍', description: 'Monitor shipments and delivery status', color: '#3182ce' },
    { id: 'shipping', title: 'Export Label', icon: '📦', description: 'For Export Shipments', color: '#38a169' },
    { id: 'bulk-shipping', title: 'Bulk Shipment', icon: '📑', description: 'Generate bulk shipments from Excel', color: '#0ea5e9' },
    { id: 'fc-label', title: 'Import Control Label', icon: '🏷️', description: 'For Import Shipments', color: '#6366f1' },
    { id: 'request-fc', title: 'Request Base FC Module', icon: '📋', description: 'Request base FC module access', color: '#8b5cf6' },
    { id: 'rating', title: 'Rating', icon: '💰', description: 'Calculate shipping rates and costs', color: '#d69e2e' },
    { id: 'search-zone', title: 'Search Zone', icon: '🌍', description: 'Find shipping zones and locations', color: '#805ad5' },
    { id: 'address-validation', title: 'Address Validation', icon: '✅', description: 'Verify shipping addresses', color: '#e53e3e' },
    { id: 'settings', title: 'Settings', icon: '⚙️', description: 'Configure application preferences', color: '#4a5568' },
    { id: 'user-access', title: 'User Access', icon: '👤', description: 'Manage user permissions', color: '#319795' },
    { id: 'billing', title: 'Billing', icon: '💵', description: 'View shipment history and costs', color: '#38a169' },
    { id: 'reports', title: 'Reporting Analytics', icon: '📊', description: 'Advanced business intelligence and sales reports', color: '#f59e0b' },
    { id: 'company', title: 'Company Management', icon: '🏢', description: 'Create & manage multi-tenant companies', color: '#553c9a' },
    { id: 'ops-security-scanning', title: 'OPS Security Scanning', icon: '🛡️', description: 'Real-time barcode scanning and duplicate check', color: '#ec4899' },
    { id: 'ops-receiving', title: 'OPS Receiving', icon: '📦', description: 'Package receiving with barcode & 4x6 label printing', color: '#0284c7' },
];

const Dashboard = ({ onSelectTool, userModules = [], isSuperUser = false, companyName = "", companySlug = "" }) => {
    // ── SECURITY: 'company' module ONLY for global super users, NEVER for company users ──
    // This prevents company admins from seeing Company Management
    const visibleTools = isSuperUser ? tools : tools.filter(t => t.id !== 'company' && userModules.includes(t.id));

    // Add API Docs card — visible to all logged-in users
    const showApiDocs = true;
    const apiDocsTool = { id: 'webhook-docs', title: 'API Documentation', icon: '🔌', description: 'Integrate your systems via REST API webhooks', color: '#0f4c81' };
    const allVisibleTools = showApiDocs ? [...visibleTools, apiDocsTool] : visibleTools;



    return (
        <div className="dashboard-container">
            <header className="dashboard-header animated fadeInDown">
                <div className="logo-section">
                    <div className="logo-icon">WB</div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h1>WEB SHIPPING</h1>
                        {companyName && (
                            <div style={{
                                fontSize: '0.75rem',
                                marginTop: '4px',
                                color: '#666',
                                fontWeight: 500,
                                letterSpacing: '0.5px'
                            }}>
                                Company: <strong>{companyName}</strong>
                            </div>
                        )}
                    </div>
                </div>
                <p>Enterprise Logistics Management Suite</p>
            </header>

            <div className="tools-grid">
                {allVisibleTools.length === 0 ? (
                    <div className="no-tools">
                        <p>No tools available for your account. Contact an administrator for access.</p>
                    </div>
                ) : (
                    allVisibleTools.map((tool, index) => (
                        <div
                            key={tool.id}
                            className="tool-card animated fadeInUp"
                            style={{ animationDelay: `${index * 0.1}s`, '--accent-color': tool.color }}
                            onClick={() => onSelectTool(tool.id)}
                        >
                            <div className="tool-icon-wrapper">
                                <span className="tool-icon">{tool.icon}</span>
                            </div>
                            <div className="tool-info">
                                <h3>{tool.title}</h3>
                                <p>{tool.description}</p>
                            </div>
                            <div className="card-action">
                                <span>Launch Tool</span>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                            </div>
                        </div>
                    ))
                )}
            </div>


            <footer className="dashboard-footer">
                <p>&copy; 2026 WEB SHIPPING. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Dashboard;
